<template>
  <b-container fluid class="theme-green">
    <div class="page-header">
      <Navbar text="Mixed Reality Viewer" />
    </div>

    <section>
      <div class="row">
        <div class="col-sm-6">
          <h2>
            Models
            <StorageStatus
              :stored="modelsCount"
              :limit="modelsLimit"
            />
          </h2>
        </div>
        <div class="col-sm-6 text-right">
          <div style="display: inline; margin-right: 10px;">
            <b-button-group>
              <b-button variant="danger" :disabled="!modelsSelected" @click="removeSelectedModels()">
                Remove {{ this.selectedModelsCount > 0 ? "(" + this.selectedModelsCount + ")" : ""}}
              </b-button>
            </b-button-group>
          </div>
          <b-button
            variant="primary"
            v-b-modal.upload-model-modal
            :disabled="!canUploadModel"
          >
            Upload
          </b-button>
        </div>
      </div>

      <ModelsDeck
        ref="modelsDeck"
        v-if="isLoggedIn"
        :storage-type="storageType"
        v-on:models-loaded="onModelsLoaded"
        v-on:models-toggled="onModelsToggled"
      />

      <b-modal
        :id="MODAL_ID_UPLOAD"
        size="lg"
        centered
        role="dialog"
        modal-class="regular"
        hide-header-close
        hide-footer
      >
        <template slot="modal-header" slot-scope="{ close }">
          <h5 class="modal-title">Upload Model</h5>
          <button
            type="button"
            class="close"
            @click="close()"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </template>
        <template slot="default">
          <UploadModel
            :storage-type="storageType"
            formats=".gltf,.glb,.fbx"
            v-on:model-uploaded="onModelUploaded"
          />
        </template>
      </b-modal>
    </section>
  </b-container>
  <!-- <b-container fluid class="theme-green no-padding">
    <b-container fluid>
      <div class="page-header">
        <Navbar text="My Models" />
      </div>

      <div class="card mt-3">
        <div class="card-body">
          <div class="row align-items-center mb-3">
            <div class="col-sm-6">
              <h2 class="card-title">My Models</h2>
            </div>
            <div class="col-sm-6 text-right">
              <b-button
                v-b-modal.upload-model-modal
                class="btn text-uppercase"
                :disabled="!canUploadModel"
                >Upload
              </b-button>
            </div>
          </div>

          <ModelsGrid
            :storage-type="storageType"
            modelFormats=".fbx"
            v-on:models-loaded="onModelsGridModelsLoaded"
          />
        </div>
      </div>
    </b-container>
  </b-container> -->
</template>

<script>
import ModelsDeck from "@/components/Views/ModelsDeck";
import StorageStatus from "@/components/Views/StorageStatus";
import Navbar from "@/components/Navigation/Navbar";
import UploadModel from "@/components/Views/UploadModel";
import * as harpraApi from "@/services/api.service";
import * as routerUtils from "@/utils/router-utils";
import { mapGetters } from "vuex";

export default {
  name: "Models",
  components: {
    Navbar,
    ModelsDeck,
    UploadModel,
    StorageStatus,
  },
  data() {
    return {
      MODAL_ID_UPLOAD: "upload-model-modal",
      storageType: harpraApi.StorageType.Standard,
      modelsCount: null,
      modelsLimit: null,
      canUploadModel: false,
      selectedModelsCount: 0,
    };
  },
  mounted() {
    if (this.$route.query["add"]) {
      routerUtils.removeQueryParam(this, "add");
      this.$bvModal.show(this.MODAL_ID_UPLOAD);
    }
  },
  computed: {
    ...mapGetters([ "isLoggedIn", "subscriptionInfo" ]),
    modelsSelected () {
      return this.selectedModelsCount > 0;
    }
  },
  methods: {
    onModelsLoaded: function(models) {
      this.modelsCount = models.length;
      this.modelsLimit = this.subscriptionInfo.modelNo;
      this.canUploadModel = this.modelsCount < this.modelsLimit;
    },
    onModelsToggled: function(selectedCount) {
      this.selectedModelsCount = selectedCount;
    },
    async removeSelectedModels() {
      await this.$refs.modelsDeck.removeSelectedModels();
    },
    async onModelUploaded() {
      await this.$refs.modelsDeck.loadModels();
    },
  },
};
</script>
